module.exports = __webpack_public_path__ + "static/media/Group 6440.831c53b8.svg";